export function getRandomId(bits: number = 36): string {
    return Math.random().toString(bits).substr(2, 9);
}

export function newInstanceToObject(object: any): any {
    return  JSON.parse(JSON.stringify(object));
}

export function compareObjects(original, compare, recursiveSearch: boolean): CompareObjects {
    const obj = new CompareObjects(original, compare);

    for (const [item, value] of Object.entries(original)) {

        if (original[item] != null && compare[item] != null) {

            if ( recursiveSearch && (isBothArray(original[item], compare[item]) || isBothObject(original[item], compare[item]))) {

                const aux = compareObjects(original[item], compare[item], recursiveSearch);

                if (!aux.IsEqual) {
                    obj.IsEqual = false;
                    aux.DiferentObjects.forEach(element => {
                        obj.DiferentObjects.push(element);
                    });
                }
            } else {
                if (!IsEqual(original[item], compare[item])) {
                    obj.IsEqual = false;
                    obj.DiferentObjects.push(new DiferentObject(original, compare, item));
                }
            }
        }
    }
    return obj;
}


export function compareOnlyRelevantProperties(
  original,
  compare,
  recursiveSearch: boolean,
  relevantProperties: Array<RelevantProperty> = []
): CompareObjects {
    const obj: CompareObjects = new CompareObjects(original, compare),
        isRelevantInformed: boolean = relevantProperties != null && relevantProperties.length > 0;

    if (!isRelevantInformed) {
        obj.IsEqual = true;
        return obj;
    }

    if (!obj.IsEqual) {
      return obj;
    }

    for (const [item, value] of Object.entries(original)) {
        const property = getRelevantProperty(relevantProperties, item);
        if (compare[item] != null) {
            if (property == null && obj.Type !== TypeEnum.Array) {
                continue;
            }
            if (recursiveSearch && (isBothArray(original[item], compare[item]) || isBothObject(original[item], compare[item]))) {
                const aux = compareOnlyRelevantProperties(
                  original[item],
                  compare[item],
                  recursiveSearch,
                  property != null ? property.Children : relevantProperties
                );
                if (!aux.IsEqual) {
                    obj.IsEqual = false;
                    aux.DiferentObjects.forEach(element => {
                        obj.DiferentObjects.push(element);
                    });
                }
            } else {

                if (property.Name === item && !IsEqual(original[item], compare[item])) {
                    obj.IsEqual = false;
                    obj.DiferentObjects.push(new DiferentObject(original, compare, item));
                }
            }
        }
    }
    return obj;
}


//#region Verification

export function IsEqual(original: any, compare: any): boolean {
    return original === compare;
}

export function isArray(original: any): boolean {
    return Array.isArray(original);
}

export function isObject(original: any): boolean {
    return typeof(original) === 'object';
}

export function isDate(object): boolean {
    let isDate = false;

    if (object && object.constructor) {
      isDate = object.constructor.toString() === new Date().constructor.toString();
    }

    return isDate;
}

//#region Dual Verification

export function isBothArray(original: any, compare: any): boolean {
    return isArray(original) && isArray(compare);
}

export function isBothObject(original: any, compare: any): boolean {
    return isObject(original) && isObject(compare);
}

export function isBothDate(original: any, compare: any): boolean {
    return isDate(original) && isDate(compare);
}

//#endregion

//#endregion

//#region Utils

export function getRelevantProperty( relevantProperties: Array<RelevantProperty>, name: string) {
    return relevantProperties.find(value => {
        return value.Name === name;
    });
}

export function clearObject(object: any) {
  if (object) {
    for (const [item, value] of Object.entries(object)) {
      if (object[item] != null) {
        const isArrayAux = isArray(object[item]),
        isObjectAux = isObject(object[item]),
        isDateAux = isDate(object[item]);

        if (isDateAux || !(isObjectAux || isArrayAux)) {
          object[item] = null;
        } else if (isArrayAux) {
          object[item] = [];
        } else if (isObjectAux) {
          clearObject(object[item]);
        }
      }
    }
  }
}

//#endregion

export class CompareObjects {

    IsEqual = true;
    Type: TypeEnum;
    DiferentObjects: Array<DiferentObject> = [];

    private _original: any;
    private _compare: any;

    constructor(original, compare) {
        this._compare = compare;
        this._original = original;

        if (isBothArray(original, compare)) {
            this.Type = TypeEnum.Array;
        } else if (isBothObject(original, compare) && !isBothDate(original, compare)) {
            this.Type = TypeEnum.Object;
        } else {
            this.Type = TypeEnum.Property;
        }

        if (this.Type === TypeEnum.Array) {
            this.IsEqual = original.length === compare.length;

            if (!this.IsEqual) {
                this.DiferentObjects.push(new DiferentObject(original, compare, 'length'));
            }
        } else {
            this.IsEqual = original != null && compare != null;
        }
    }

    get Changes() {
        return  this.DiferentObjects.length;
    }
}

export class DiferentObject {

    constructor(original: any, compare: any, item: string) {
        this.Property = item;
        this.PreviousValue = original[item];
        this.CurrentValue = compare[item];
    }

    Property: string;
    PreviousValue: any;
    CurrentValue: any;
}

export class RelevantProperty {

    constructor(
      name: string,
      type: TypeEnum = TypeEnum.Property,
      children: Array<RelevantProperty> = []
    ) {
        this.Name = name;
        this.Children = children;
        this.Type = type;
    }

    Name: string;
    Type: TypeEnum;
    Children: Array<RelevantProperty> = [];
}

export enum TypeEnum {
    Array = 1,
    Object = 2,
    Property = 3,
}
